import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Collapse
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import ReplyIcon from "@material-ui/icons/MessageOutlined";
import FlagIcon from "@material-ui/icons/Flag";
import AddCommentField from "./AddCommentField";
import { connect } from "react-redux";
import {
  deleteComment,
  deleteSubComment,
  toggleReportComment
} from "../../store/actions/commentActions";
import { addMorePoints } from '../../store/actions/freshCardActions'
import { getRealPoints } from '../../store/actions/realPointsActions'
import { GET_POINTS, CLEAR_POINTS, SHOW_TOAST } from "../../store/actions/types";
import { PHOTO_PROFILE } from "./../../utils/photo_utils";
import {
  fetchUserBiography,
  openUserProfileDialog
} from "../../store/actions/userBiographyActions";
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { showToast } from '../../store/actions/toastAction'
import firebase from './../../store/firebase';
import { COMMENT_REPORT_LIMIT } from "../../constants";
import { POINT_CONFIG } from '../../utils/point_conversion_utils';

const CommentItem = ({
  comment,
  commentID,
  classes,
  openReply,
  onRemoveComment,
  onToggleExpandReply,
  post,
  postType,
  userData,
  onViewUserDialog,
  showLeadb,
  onReportComment
}) => {
  
  const commentContainerStyle = {
    display: 'flex',
    padding: '12px 16px',
    borderBottom: '1px solid #f0f3f5',
  };

  const avatarContainerStyle = {
    marginRight: '12px',
  };

  const commentBodyStyle = {
    width: '100%',
  };
  
  const commentHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px'
  };

  const commentUsernameStyle = {
    fontWeight: 600,
    fontSize: '15px',
    marginRight: '8px',
    cursor: 'pointer'
  };

  const commentDateStyle = {
    color: '#657786',
    fontSize: '14px'
  };

  const commentTextStyle = {
    fontSize: '15px',
    lineHeight: 1.5,
    wordBreak: 'break-word',
    marginBottom: '8px',
  };

  const commentActionsStyle = {
    display: 'flex',
    alignItems: 'center',
    color: '#657786',
  };

  const subCommentContainerStyle = {
    paddingLeft: '52px', // 40px avatar + 12px margin
  };

  return (
    <div style={{borderBottom: '1px solid #e6ecf0'}}>
      <div style={commentContainerStyle}>
        <div style={avatarContainerStyle}>
          <Avatar
            alt={comment.journalUserName}
            src={PHOTO_PROFILE(comment.photoURL)}
            style={{ cursor: "pointer" }}
            onClick={e => onViewUserDialog(comment)}
          />
        </div>
        <div style={commentBodyStyle}>
          <div style={commentHeaderStyle}>
            <span style={commentUsernameStyle} onClick={e => onViewUserDialog(comment)}>{comment.journalUserName}</span>
            <span style={commentDateStyle}>· {comment.stringCommentDate}</span>
          </div>
          <div style={commentTextStyle}>{comment.comment}</div>
          <div style={commentActionsStyle}>
            <IconButton size="small" onClick={onToggleExpandReply} aria-label="ReplyComment">
              <ReplyIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={onReportComment}
              aria-label="ReportComment"
            >
              <FlagIcon 
                fontSize="small" 
                style={{ color: (comment.reportedBy && comment.reportedBy[userData.userID]) ? 'red' : 'inherit' }}
              />
            </IconButton>
            {(userData.userID === comment.journalUserID || userData.userType === 7 || userData.userType === 14) && (
              <IconButton size="small" onClick={e => onRemoveComment(comment)} aria-label="DeleteComment">
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </div>
        </div>
      </div>

      {openReply && (
        <div style={{ padding: '0 16px 12px 52px' }}>
          <AddCommentField
            parentID={comment.commentID}
            isSubComment={true}
            postType={postType}
            showLeadb={showLeadb}
            post={post}
            autoFocus={true}
          />
        </div>
      )}

      {comment.subComments && (
        <div style={subCommentContainerStyle}>
            {Object.keys(comment.subComments).map(v => {
              const subComment = comment.subComments[v];
              return (
                <div key={v} style={{...commentContainerStyle, borderBottom: 'none', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                    <div style={avatarContainerStyle}>
                      <Avatar
                        alt={subComment.journalUserName}
                        src={PHOTO_PROFILE(subComment.photoURL)}
                        style={{ cursor: "pointer", width: '32px', height: '32px' }}
                        onClick={e => onViewUserDialog(subComment)}
                      />
                    </div>
                    <div style={commentBodyStyle}>
                      <div style={commentHeaderStyle}>
                        <span style={{...commentUsernameStyle, fontSize: '14px'}} onClick={e => onViewUserDialog(subComment)}>{subComment.journalUserName}</span>
                        <span style={{...commentDateStyle, fontSize: '13px'}}>· {subComment.stringCommentDate}</span>
                        {(userData.userID === subComment.journalUserID || userData.userType === 7 || userData.userType === 14) && (
                          <div style={{ marginLeft: 'auto' }}>
                            <IconButton size="small" onClick={e => onRemoveComment(subComment)} aria-label="DeleteComment">
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </div>
                        )}
                      </div>
                      <div style={{...commentTextStyle, fontSize: '14px'}}>{subComment.comment}</div>
                    </div>
                </div>
              )
            })}
        </div>
      )}
    </div>
  );
};

function makeid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
charactersLength));
  }
  return result;
}

class Comment extends Component {
  state = {
    expandReply: false
  };

  componentDidMount() {
    const { userdata, post, rrpoints } = this.props;
    if(this.props.rrpoints) {} else {
        if (this.props.post.uid) {
        var pdata = {
          type: "GET_POINTS",
          uid: this.props.post.uid,
          redpoints: rrpoints
        }
      this.props.getRealPoints(pdata);
      }
   }
 }
  handleToggleExpandReply = () => {
    this.setState(prevState => ({
      expandReply: !this.state.expandReply
    }));
  };

	pointsPass = (dbPoints, realPoints) => {
		
		
	
		var pass = false;
		if (dbPoints < realPoints) {
		  if (parseInt(realPoints) - parseInt(dbPoints) < 3) { 
			pass = true;
		  }
		} else
		{
		  if (parseInt(dbPoints) - parseInt(realPoints) < 3) { //too big - CANCEL
			pass = true;
		  } 
		}
		
		return pass;
	  }

  handleRemoveComment = async comment => {
    const { userdata, postType, post, parentID } = this.props;
    
    // Generate unique trail ID for tracking
    const makeid = (length) => {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    };

    // Only process point subtraction if commenter and post author are different people
    if (comment.journalUserID !== post.journalUserID) {
      
      try {
        // Get post author's current points
        let authorPoints, authorPointsy = 0;
        await firebase.database
          .ref('user/' + post.uid)
          .once('value', (authorSnapshot) => {
            if (authorSnapshot.exists() && authorSnapshot.val().points) {
              authorPoints = authorSnapshot.val().points;
              authorPointsy = authorSnapshot.val().pointsy || 0;
            }
          });

        // Get commenter's current points  
        let commenterPoints, commenterPointsy = 0;
        let commenterUid = null;
        
        // Find commenter's UID - need to look up user by userID
        await firebase.database
          .ref('users')
          .orderByKey()
          .equalTo(comment.journalUserID)
          .once('value', (userSnapshot) => {
            if (userSnapshot.exists()) {
              const userData = Object.values(userSnapshot.val())[0];
              commenterUid = userData.uid;
            }
          });
          
        if (commenterUid) {
          await firebase.database
            .ref('user/' + commenterUid)
            .once('value', (commenterSnapshot) => {
              if (commenterSnapshot.exists() && commenterSnapshot.val().points) {
                commenterPoints = commenterSnapshot.val().points;
                commenterPointsy = commenterSnapshot.val().pointsy || 0;
              }
            });
        }

        // Subtract points from post author (who received the comment)
        if (authorPoints !== undefined && post.execmember === true) {
          let authorData = {
            uid: post.uid,
            userID: post.journalUserID,
            pointsCurrent: authorPoints,
            ypointsCurrent: authorPointsy,
            leadPoints: post.leadPoints ? post.leadPoints : 0,
            pointsAdded: -POINT_CONFIG.COMMENT_AUTHOR_POINTS, // Negative points
            trailID: makeid(10),
            companyName: post.companyName,
            firstName: post.journalUserName,
            lastName: "empty",
            title: comment.comment,
            actionType: "Comment deleted",
            actionDesc: "LEAD comment deleted - author points subtracted",
            currentUser: userdata.userID,
            leadID: post.dailyThoughtID ? post.dailyThoughtID : "",
            groupid: post.groupid ? post.groupid : ''
          };

          this.props.addMorePoints(authorData);
        }

        // Subtract points from commenter (who wrote the comment)
        if (commenterPoints !== undefined && commenterUid) {
          // Check if commenter is exec member
          await firebase.database
            .ref('user/' + commenterUid)
            .once('value', (commenterSnapshot) => {
              if (commenterSnapshot.exists()) {
                const commenterData = commenterSnapshot.val();
                
                if (commenterData.execmember === true) {
                  let commenterPointData = {
                    uid: commenterUid,
                    userID: comment.journalUserID,
                    pointsCurrent: commenterPoints,
                    ypointsCurrent: commenterPointsy,
                    leadPoints: 0, // Commenter doesn't affect lead points
                    pointsAdded: -POINT_CONFIG.COMMENT_LIKER_POINTS, // Negative points
                    trailID: makeid(10),
                    companyName: comment.companyName || 'Unknown',
                    firstName: comment.journalUserName.split(' ')[0] || 'Unknown',
                    lastName: comment.journalUserName.split(' ')[1] || 'empty',
                    title: "Comment deleted",
                    actionType: "Comment deleted",
                    actionDesc: "LEAD comment deleted - commenter points subtracted",
                    currentUser: userdata.userID,
                    leadID: post.dailyThoughtID ? post.dailyThoughtID : "",
                    groupid: post.groupid ? post.groupid : ''
                  };

                  this.props.addMorePoints(commenterPointData);
                }
              }
            });
        }

      } catch (error) {
        // Error processing point subtraction
      }
    }

    if (this.props.showLeadb) {
      this.props.showLeadb(this.props.post, 'comment deleted');
    }

    // Proceed with actual comment deletion
    let commentParams = {
      postType: postType,
      comment: comment.comment,
      commentID: comment.commentID,
      dailyThoughtType: post.dailyThoughtType,
      groupid: post.groupid,
      groupname: post.groupname,
      postID: post.dailyThoughtID
        ? post.dailyThoughtID
        : post.videoID || post.podcastID || post.newsID
    };

    if (comment.parentID) {
      commentParams.parentID = comment.parentID;
      this.props.deleteSubComment(commentParams);
    } else {
      this.props.deleteComment(commentParams);
    }
  };

  handleToggleExpandReply = () => {
    this.setState(prevState => ({
      expandReply: !this.state.expandReply
    }));
  };
  openViewUserDialog = post => {
    var params = {
      userID: post.journalUserID,
      userName: post.journalUserName,
      companyID: post.companyID,
      companyName: post.companyName,
      photoURL: PHOTO_PROFILE(post.photoURL),
      showprofiledlg: true
    };

    // Fetch user bio data
    this.props.fetchUserBiography({ ...params, type: "USER_BIOGRAPHY" });

    // Open user profile dialog
    this.props.openUserProfileDialog(params);
  };

  handleToggleFlag = () => {
    const { toggleReportComment, comment, userdata } = this.props;
    toggleReportComment(comment, userdata);
  };

  render() {
    const { commentID, userdata, showLeadb } = this.props;
    return (
      <CommentItem
        openReply={this.state.expandReply}
        onToggleExpandReply={this.handleToggleExpandReply}
        commentID={commentID}
        onRemoveComment={this.handleRemoveComment}
        onReportComment={this.handleToggleFlag}
        onViewUserDialog={this.openViewUserDialog}
        showLeadb={showLeadb? showLeadb: ''}
        userData={userdata}
        {...this.props}
      />
    );
  }
}

Comment.propTypes = {};

const mapStateToProps = (state, ownProps) => {
  return {
    userdata: state.userDialog.userDetails[0],
    rrpoints: state.realpoints.realpoints
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUserBiography: params => dispatch(fetchUserBiography(params)),
    openUserProfileDialog: params => dispatch(openUserProfileDialog(params)),
    deleteComment: params => dispatch(deleteComment(params)),
    deleteSubComment: params => dispatch(deleteSubComment(params)),
    addMorePoints: params => dispatch(addMorePoints(params)),
    getRealPoints: params => dispatch(getRealPoints(params)),
    showToast: params => dispatch(showToast(params)),
    toggleReportComment: (comment, user) => dispatch(toggleReportComment(comment, user))
  };
};
 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Comment);
